import React, {useEffect, useState, useRef} from "react";
import {connect, useSelector} from "react-redux";
import {addProject, editProject} from "../../actions/projects";
import {Link} from "react-router-dom";
import {logout} from "../../actions/auth";

// GitHub request 2026-09-19: despite its name, this component previously only ever created a
// NEW project -- the form always started blank and unconditionally called addProject, even when
// reached with an existing project's id. editProject (client/src/actions/projects.js) already
// existed but had no caller anywhere. Now: editing mode is "is this project already in Redux
// state" (props.match.params.id !== "new"), pre-fills the form from it, and calls editProject
// instead, matching ProjectViewSet.update()'s now-real field-edit branch (projects/views.py).
export function ProjectEdit(props) {

const project = useSelector(state => state.projects.project);
const status = useSelector(state => state.auth.status);
const isAuthenticated = status === "authenticated";
const isEditing = props.match.params.id !== "new";

const [newProject, setNewProject] = useState(isEditing ? {
    project_name: project.project_name || "",
    project_number: project.project_number || "",
    country: project.country || "",
    street: project.street || "",
    city: project.city || "",
    state: project.state || "",
    postal: project.postal || "",
    project_description: project.project_description || "",
} : {});
const [submitting, setSubmitting] = useState(false);

const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    isEditing ? props.editProject(project.project_id, newProject) : props.addProject(newProject);
}

const handleChange = (e) => {
    setNewProject({ ...newProject, [e.target.id]: e.target.value})
}

const isInitialMount = useRef(true);

useEffect(() => {
    if (isInitialMount.current) {
        isInitialMount.current = false;
     } else {
        //fires once the CREATE_PROJECT/EDIT_PROJECT dispatch updates this project in Redux --
        //routes to the (new or freshly-edited) project's own view page either way, confirming
        //the save landed by showing the now-current info
        project.project_id && props.handleReroute(`/mng/project/view/${project.project_id}`)
     }
}, [project])


    return (
        <div className={isAuthenticated ? "" : "flex-column center" }>
            <div className="card-wrapper gap-below-m ">
                <div className="single-header">
                    <div  className="iblock vtop"><h1 className="title heavy iblock">{isEditing ? "Edit Project" : "New Project"}</h1></div>
                </div>
                <div className="flex-column content-wrapper" >
                    <form onSubmit={(e) => handleSubmit(e)} className="form" >
                        <div className="inputs-wrapper gap-below-m">
                            <div className="input-basic">
                                <input
                                type="text"
                                name="project_name"
                                id="project_name"
                                value={newProject.project_name || ""}
                                onChange={(e) => handleChange(e)}
                                required
                                />
                                <label htmlFor="project_name">Project Name <span>*</span></label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="text"
                                name="project_number"
                                id="project_number"
                                value={newProject.project_number || ""}
                                onChange={(e) => handleChange(e)}
                                />
                                <label htmlFor="project_number">Project Number</label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="text"
                                name="country"
                                id="country"
                                value={newProject.country || ""}
                                onChange={(e) => handleChange(e)}
                                required
                                />
                                <label htmlFor="country">Country <span>*</span></label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="text"
                                name="street"
                                id="street"
                                value={newProject.street || ""}
                                onChange={(e) => handleChange(e)}
                                required
                                />
                                <label htmlFor="street">Street Address <span>*</span></label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="text"
                                name="city"
                                id="city"
                                value={newProject.city || ""}
                                onChange={(e) => handleChange(e)}
                                required
                                />
                                <label htmlFor="city">City <span>*</span></label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="text"
                                name="state"
                                id="state"
                                value={newProject.state || ""}
                                onChange={(e) => handleChange(e)}
                                />
                                <label htmlFor="state">Province/State</label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="text"
                                name="postal"
                                id="postal"
                                value={newProject.postal || ""}
                                onChange={(e) => handleChange(e)}
                                />
                                <label htmlFor="postalcode">Postal Code</label>
                            </div>
                            <div className="input-basic textarea addspace">
                                <label className="textarea" htmlFor="project_description">Project Description</label>
                                <textarea type="text" name="project_description" id="project_description" rows="3" value={newProject.project_description || ""} onChange={(e) => handleChange(e)}/>
                            </div>
                        </div>
                        <div className="flex-row" style={{justifyContent: "flex-end"}}>
                            <button type="submit" id="addproject" className="btn pri min-width gap-right-xs" disabled={submitting}>
                                {submitting ? "Please wait..." : "Save"}
                            </button>
                            <Link to={isEditing ? `/mng/project/view/${project.project_id}` : "/mng/projects/all"} >
                                <button id="canceladdproject" className="btn secmin-width " disabled={submitting}>
                                    Cancel
                                </button>
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {addProject, editProject, logout})(ProjectEdit);